import {
    useDateTimeLocalizationInfo,
    useTimezone,
    DateService,
    DateTimeService,
    LocalizedShortTime,
} from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';

interface DateTimeLabelProps {
    dateUtc: string;
}

export const DateTimeLabel = ({ dateUtc }: DateTimeLabelProps) => {
    const dateTimeLocalizationInfo = useDateTimeLocalizationInfo();
    const timezone = useTimezone();
    const dateTime = DateTimeService.fromUtcString(dateUtc, timezone);
    const date = DateTimeService.toDate(dateTime);
    const dateStr = DateService.toLongString(date, dateTimeLocalizationInfo);

    return (
        <span>
            {dateStr}
            {UnicodeEntity.Space}
            <LocalizedShortTime dateTime={dateTime} />
        </span>
    );
};
